import script from "./QrGenerator.vue?vue&type=script&lang=js"
export * from "./QrGenerator.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__